import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { signOut } from 'firebase/auth';

import { ui, uiConfig, auth } from '../../firebase';
import { Section, Layout, SEO } from '..';
import style from './LoveMessage.module.less';
import { CreateMessage } from './CreateMessage';
import social from './assets/social.png';

export const LoveMessageAdminPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState('');
  const [messageId, setMessageId] = useState('');

  useEffect(() => {
    const m = (new URLSearchParams(window.location.search)).get('m');
    if (m) {
      setMessageId(m);
    } else {
      auth.onAuthStateChanged((authResult) => {
        if (authResult) {
          setEmail(authResult.email || '');
          setMessageId(authResult.uid);
          setIsLoggedIn(true);
        } else {
          ui.start('#firebase-login', uiConfig);
        }
      });
    }
  }, []);

  return (
    <Layout>
      <SEO
        title="Mysterious message"
        description="Hide a message behind a series of puzzles. Share with your spouse, love interest or a friend. All that for free!"
        image={social}
      />

      <Section className={classnames(style.firstSection, style.login)}>
        <div className={classnames(style.content, style.contentNarrow)}>
          {messageId && isLoggedIn ? (
            <>
              <div className={style.loginData}>
                Logged in as: <strong>{email}</strong>. {' '}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  onClick={(ev) => {
                    ev.preventDefault();
                    signOut(auth);
                    setIsLoggedIn(false);
                    setEmail('');
                  }}
                >
                  Sign out
                </a>
              </div>
              <CreateMessage messageId={messageId} />
            </>
          ) : <></>}

          <div className={classnames(style.row)}>
            <div className={classnames(style.text, style.form)}>
              {email ? <></> : <div id="firebase-login" />}
            </div>
          </div>
        </div>
      </Section>
    </Layout>
  );
};
